<nested-node-select-insight
    [nodes]="localState?.nodes"
    [selection]="localState?.selection"
    (change)="_onChange($event)"
>
</nested-node-select-insight>
